import React, { createContext, useContext, ReactNode } from "react";
import { useProjects } from "@root/hooks/useProjects";

const defaultState: any = {};

const ProjectsContext = createContext<any>(defaultState);

interface ProjectsProviderProps {
  children: ReactNode;
}

export const ProjectsProvider: React.FC<ProjectsProviderProps> = ({
  children,
}) => {
  const data = useProjects();
  return (
    <ProjectsContext.Provider value={data}>{children}</ProjectsContext.Provider>
  );
};

export const useProjectsContext = () => {
  return useContext(ProjectsContext);
};
